export default __webpack_public_path__ + "static/tube-desktop@2x-f93341205878b7a9d79d11d38f4eb135.webp";